import { useApiService, useDataApiState } from "hooks";
import { Modal } from "pageFramework/modals";
import { ReadOnlyField } from "pageFramework/uiControls/inputs";
import { Grid, GridCol } from "pageFramework/uiControls/layouts";
import LoadingIndicator from 'components/loadingIndicator';
import { useEffect } from "react";
import { createCalendarScheduleService } from "services";
import { ScheduleBlockSummary } from "types";

interface BlockDetailsModalProps {
	show: boolean;
	onClose: () => void;
	refGuid: string;
}

export const BlockDetailsModal: React.FC<React.PropsWithChildren<BlockDetailsModalProps>> = (props) => {
	const { show, onClose, refGuid } = props;

    const [blockSummary, setBlockSummary] = useDataApiState<ScheduleBlockSummary>();

	const calendarScheduleService = useApiService(createCalendarScheduleService);

	useEffect(() => {
		if (refGuid) calendarScheduleService.getBlockSummary(refGuid, setBlockSummary);
	}, [refGuid, setBlockSummary]);

    return (
			<Modal
				show={show}
				title="Block Details"
				onClose={onClose}
				showCloseButton={true}
				size="large"
			>
				{blockSummary.loading || !blockSummary.data ? (
					<LoadingIndicator />
				) : (
					<Grid numberOfColumns={1}>
						<GridCol>
							<Grid numberOfColumns={2}>
								<GridCol>
									<ReadOnlyField label="Start Date">{blockSummary.data?.startDate}</ReadOnlyField>
								</GridCol>
								<GridCol>
									<ReadOnlyField label="End Date">{blockSummary.data?.endDate}</ReadOnlyField>
								</GridCol>
							</Grid>
						</GridCol>
                        <GridCol>
							<Grid numberOfColumns={2}>
								<GridCol>
                                    <ReadOnlyField label="Start Time">{blockSummary.data?.startTime}</ReadOnlyField>
								</GridCol>
								<GridCol>
                                    <ReadOnlyField label="End Time">{blockSummary.data?.endTime}</ReadOnlyField>
								</GridCol>
							</Grid>
						</GridCol>
						<GridCol>
							<ReadOnlyField label="Last Modified">{blockSummary.data?.lastModified}</ReadOnlyField>
						</GridCol>
					</Grid>
				)}
			</Modal>
		);
}

export default BlockDetailsModal